module.exports = __webpack_public_path__ + "static/img/gift_head.d8fd08df.png";